import { useQuery } from "@tanstack/react-query";

import { api, unwrap } from "../api/client";

/** Aktivni poslovni moduli (ENABLED_MODULES na backendu). Jezgro je uvijek aktivno. */
export function useModules(): (m?: string) => boolean {
  const info = useQuery({
    queryKey: ["info"], staleTime: Infinity,
    queryFn: async () => unwrap(await api.GET("/api/v1/system/info")) as { modules?: string[] },
  });
  const mods = new Set(info.data?.modules ?? []);
  return (m?: string) => !m || mods.has(m);
}
